/* product page enqury form */

function checkForm() {
    var qty = document.getElementById("qtyInput").value;
    var name = document.getElementById("nameInput").value;
    var email = document.getElementById("emailInput").value;
    var phone = document.getElementById("phoneInput").value;

    // Email validation regular expression
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Enable submit button only if all required fields are filled and email is valid and phone number is 10 digits
    var submitButton = document.getElementById("submitButton");
    var emailErrorMessage = document.getElementById("emailErrorMessage");
    var phoneErrorMessage = document.getElementById("phoneErrorMessage");

    if (qty && name && email && emailPattern.test(email) && phone && phone.length === 10 && !isNaN(phone)) {
        submitButton.disabled = false;
        emailErrorMessage.style.display = "none"; // Hide email error message
        phoneErrorMessage.style.display = "none"; // Hide phone error message
    } else {
        submitButton.disabled = true;
        if (!email || !emailPattern.test(email)) {
            emailErrorMessage.style.display = "block"; // Show email error message
        } else {
            emailErrorMessage.style.display = "none"; // Hide email error message
        }
        if (!phone || phone.length !== 10 || isNaN(phone)) {
            phoneErrorMessage.style.display = "block"; // Show phone error message
        } else {
            phoneErrorMessage.style.display = "none"; // Hide phone error message
        }
    }
}

// Define the submitForm function
function submitForm(event) {
    var form = document.getElementById("myForm");
    var formData = new FormData(form);
    var loadingMessage = document.getElementById("loadingMessage");
    var thankYouMessage = document.getElementById("thankYouMessage");
    // Show the loading state
    loadingMessage.style.display = "flex";
    loadingMessage.classList.add("highlight");
    form.classList.add("blur");

    // Use fetch to POST form data to the Google Apps Script endpoint
    fetch(form.action, {
        method: "POST",
        body: formData,
    })
    .then(response => {
        // Check if the response was successful
        if (response.ok) {
            return response.text(); // Get the response text (the echo URL)
        }
        throw new Error("Form submission failed!");
    })
    .then(data => {
        // Check if the response contains the echo URL or success marker
        if (data.includes("script.googleusercontent.com")) {
            // Hide the form and show the thank you message
            form.style.display = "none";
            thankYouMessage.style.display = "block";
            
            // Scroll to the desired element
            document.querySelector(".new_category_heaidng.dots-container.recomendation_container_heading").scrollIntoView({ behavior: 'smooth' });
        } else {
            throw new Error("Unexpected response from the server.");
        }
    })
    .catch(error => {
        console.error(error.message);
    })
    .finally(() => {
        // Hide loading state and reset styles
        loadingMessage.style.display = "none";
        loadingMessage.classList.remove("highlight");
        form.classList.remove("blur");
        form.style.display = "none";
        thankYouMessage.style.display = "block";
    });
}

// Listen for input events on required fields
document.getElementById("qtyInput")?.addEventListener("input", checkForm);
document.getElementById("nameInput")?.addEventListener("input", checkForm);
document.getElementById("emailInput")?.addEventListener("input", checkForm);
document.getElementById("phoneInput")?.addEventListener("input", checkForm);

// mobile number validation

document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("phone")?.addEventListener("input", function () {
    var phoneNumber = this.value;
    var isValidPhoneNumber = /^\d{10}$/.test(phoneNumber);
    if (!isValidPhoneNumber) {
      this.setCustomValidity("Please enter a 10-digit number.");
    } else {
      this.setCustomValidity("");
    }
  });
});





// in the Quantity field it will take only numbers
function allowOnlyNumbers(inputElement) {
    inputElement?.addEventListener('input', function() {
        // Remove any non-numeric characters
        this.value = this.value.replace(/\D/g, '');
    });
}

// Call the function for the quantity input
allowOnlyNumbers(document.getElementById('qtyInput'));

// Limit the input value to a maximum length of 10 characters
document.addEventListener("DOMContentLoaded", function () {
    document.getElementById("phoneInput")?.addEventListener("input", function () {
        // Get the input value
        var inputValue = this.value;
        // Remove any non-numeric characters using a regular expression
        var numericValue = inputValue.replace(/\D/g, '');
        if (numericValue.length > 10) {
            numericValue = numericValue.substring(0, 10);
        }

        // Update the input value
        this.value = numericValue;
    });
});

